import { Button, Form, Switch } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Dragger from 'antd/es/upload/Dragger';
import GeneralHeader from 'components/common/GeneralHeader';
import Success from 'components/common/view/success';
import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateActiveTask } from 'utils';

type userPropType = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  title: string;
  avatar: avatarType;
};
export type avatarType = {
  id: number;
  name: string;
  source: string;
  url: string;
};
type ModifyActiveTaskType = {
  id?: number;
  model_type: string;
  notification: boolean;
  recipients: userPropType[];
  status: string;
  title: string;
  due_date: string;
  description: string;
  attached_file: string | null;
  showModal: boolean;
  user: userPropType;
};

const ModifyActiveTask = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateActiveTask, getExistUser } = useMember();
  const { successNotification, error } = useNotice();

  const [state, setState] = useState({
    taskData: location.state.taskData as ModifyActiveTaskType,
    recipients_ids: location.state.taskData.recipients.map((item) => {
      return item.id;
    }) as number[],
    listUsersOptions: [] as {
      id: number;
      checked: boolean;
    }[],
    successed: false,
  });
  const { recipients_ids, listUsersOptions, successed, taskData } = state;
  const formik = useFormik({
    initialValues: {
      id: taskData.id,
      title: taskData.title,
      model_type: taskData.model_type,
      status: taskData.status,
      due_date: taskData.due_date,
      notification: taskData.notification,
      description: taskData.description,
    } as updateActiveTask,
    onSubmit: (data: updateActiveTask) => {
      const finalData = {
        ...data,
        recipients_ids: recipients_ids.length > 0 ? recipients_ids : null,
      };
      updateActiveTask(finalData as updateActiveTask)
        .then((res) => {
          if (res.status === 204) {
            navigate('/on_boarding', {
              state: { boarding_id: location?.state?.boarding_id },
            });
            successNotification('The task has been modified.');
          }
        })
        .catch((e) => error('Something went wrong'));
    },
  });

  const handleOnCheck = (key: number) => {
    if (recipients_ids.some((item) => item === key)) {
      setState((pre) => ({
        ...pre,
        recipients_ids: recipients_ids.filter((item) => item !== key),
        listUsersOptions: listUsersOptions?.map(
          (item: { id: number; checked: boolean }) => {
            if (item.id === key) {
              return { ...item, checked: !item.checked };
            }
            return item;
          },
        ),
      }));
    } else {
      setState((pre) => ({
        ...pre,
        recipients_ids: [...recipients_ids, key],
        listUsersOptions: listUsersOptions?.map(
          (item: { id: number; checked: boolean }) => {
            if (item.id === key) {
              return { ...item, checked: !item.checked };
            }
            return item;
          },
        ),
      }));
    }
  };

  useEffect(() => {
    getExistUser().then((response) => {
      setState((pre) => ({
        ...pre,
        listUsersOptions: response?.data?.map(
          (item: { first_name: string; last_name: string; id: number }) => {
            return {
              ...item,
              label: `${item.first_name} ${item.last_name}`,
              checked: taskData.recipients.some(
                (recipient) => item.id === recipient.id,
              ),
              value: item.id,
            };
          },
        ),
      }));
    });
  }, []);

  return (
    <div>
      {successed ? (
        <Success
          title="The task has been updated"
          buttonTitle="MODIFIED TASK"
          nameUrl="Return to boarding"
          url={'/on_boarding'}
          setStatus={() => {}}
        />
      ) : (
        <div>
          <GeneralHeader
            pageTitle="Modification of a task"
            icon="/icons/modification_of_a_task.svg"
            child={
              <Form onFinish={formik.handleSubmit}>
                <div
                  style={{ display: 'flex', marginTop: '100px', gap: '130px' }}
                >
                  <div>
                    <span style={{ color: '#000', fontSize: 16 }}>
                      {taskData.model_type === 'on_boarding'
                        ? 'Onboarding'
                        : 'Offboarding'}
                    </span>
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                      }}
                    >
                      <img
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                        }}
                        src={
                          taskData?.user?.avatar
                            ? taskData?.user?.avatar?.url
                            : taskData?.user?.title === 'male'
                            ? '/assets/Businessman.png'
                            : '/assets/Businesswoman.png'
                        }
                        alt={'arr'}
                      />
                      <span
                        style={{ color: '#000', fontSize: 16 }}
                      >{`${taskData?.user?.first_name} ${taskData?.user?.last_name}`}</span>
                    </div>
                  </div>
                  <div>
                    <span style={{ color: '#000', fontSize: 16 }}>Type</span>
                    <div
                      className="on_boarding_creation_task_on_boarding_box"
                      style={{
                        background:
                          taskData.model_type === 'on_boarding'
                            ? '#B3F9CF'
                            : ' #FFB5B5',
                      }}
                    >
                      {taskData.model_type === 'on_boarding'
                        ? 'Onboarding'
                        : 'Offboarding'}
                    </div>
                  </div>
                  <div>
                    <span style={{ color: '#000', fontSize: 16 }}>
                      {taskData.model_type === 'on_boarding'
                        ? 'Date of contract start'
                        : 'End of contract date'}
                    </span>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: '16px',
                        lineHeight: '21px',
                        marginTop: '25px',
                        color: '#000',
                      }}
                    >
                      {dayjs(taskData.due_date).format('ddd, DD MMMM YYYY')}
                    </div>
                  </div>
                </div>
                {/* TASK*/}
                <div className="on_boarding_creation_task_task_block">
                  <h1
                    style={{
                      fontWeight: 700,
                      fontSize: '24px',
                      lineHeight: '31.2px',
                      color: '#000',
                    }}
                  >
                    Task
                  </h1>
                  <div
                    style={{
                      display: 'flex',
                      gap: '32px',
                      marginBottom: '30px',
                      marginTop: '32px',
                    }}
                  >
                    <CustomInput
                      onChange={(s) =>
                        formik.setFieldValue('title', s.target.value)
                      }
                      title="Name of the task "
                      width="70%"
                      required
                      background=" #FFFFFF"
                      defaultValue={taskData.title}
                      fontSize={12}
                      maxLength={100}
                    />
                    <CustomDatePicker
                      onChange={(e) =>
                        formik.setFieldValue(
                          'due_date',
                          e?.format('YYYY-MM-DD'),
                        )
                      }
                      format={(e) => dayjs(e).format('DD/MM/YYYY')}
                      title="Due date"
                      required
                      defaultValue={taskData && dayjs(taskData.due_date)}
                      width="29%"
                      fontSize={12}
                    />
                  </div>
                  <div className="on_boarding_creation_task_text_area">
                    <div
                      style={{
                        margin: '16px 16px 0px 10px',
                        fontWeight: '400',
                        fontSize: '10px',
                        lineHeight: '16px',
                        color: '#898989',
                      }}
                    >
                      Description
                    </div>
                    <TextArea
                      onChange={(e: any) =>
                        formik.setFieldValue('description', e.target.value)
                      }
                      defaultValue={taskData.description}
                      bordered={false}
                      rows={6}
                      style={{
                        fontFamily: 'IBM Plex Serif',
                        fontWeight: '400',
                        fontSize: '12px',
                      }}
                      autoSize={{ minRows: 7 }}
                      maxLength={200}
                    />
                  </div>
                </div>
                <div
                  style={{
                    marginTop: '32px',
                  }}
                  className={'leave_request_form'}
                >
                  <h1
                    style={{
                      fontWeight: 700,
                      fontSize: '24px',
                      lineHeight: '31.2px',
                      marginTop: '32px',
                      color: '#000',
                    }}
                  >
                    Attach File
                  </h1>
                  <div className={'leave_request_form_upload'}>
                    <h4
                      style={{
                        color: '#494949',
                        fontSize: 12,
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <p>Accepted File Types</p>{' '}
                      <p
                        style={{
                          color: '#E02C2C',
                          marginLeft: '3px',
                          marginRight: '6px',
                        }}
                      >
                        *
                      </p>{' '}
                      <p>
                        (png, .jpg, .jpeg, .gif, .pdf, .docx / Max size: 10 mb)
                      </p>
                    </h4>
                    <Dragger
                      className={'leave_request_form_upload_form'}
                      style={{
                        border: '2px dashed var(--Background, #407FDD)',
                      }}
                    >
                      <img alt="upload" src="/icons/upload.svg" />
                    </Dragger>
                  </div>
                </div>
                <div style={{ marginTop: '30px' }}>
                  <CustomDropdown
                    checkBox={true}
                    onCheckBox={(key) => handleOnCheck(key)}
                    width="70%"
                    title="Recipient(s)"
                    options={
                      listUsersOptions as {
                        id: number;
                        checked: boolean;
                        label: string;
                        value: string;
                      }[]
                    }
                    dataForCheckbox={recipients_ids}
                    fontSize={12}
                    fontSelect={12}
                    render={'Select an element'}
                  />
                </div>
                <div
                  style={{
                    marginTop: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                  className="on_boarding_text"
                >
                  <Switch
                    onChange={(e) => formik.setFieldValue('notification', e)}
                    style={{ marginTop: '15px' }}
                  />

                  <span
                    style={{ marginTop: '10px', fontSize: 12, color: '#000' }}
                  >
                    be informed when the task passes to the completed status.
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    float: 'right',
                    gap: '20px',
                    margin: '20px',
                  }}
                >
                  <Button
                    onClick={() => navigate(-1)}
                    style={{
                      background: '#fff',
                      color: '#407FDD',
                      fontSize: '16px',
                      fontWeight: 700,
                      border: 'none',
                    }}
                    className="on_boarding_creation_task_button"
                  >
                    CANCEL
                  </Button>
                  <Button
                    htmlType="submit"
                    className="on_boarding_creation_task_button"
                    style={{ fontSize: '16px', fontWeight: 700 }}
                  >
                    MODIFY
                  </Button>
                </div>
              </Form>
            }
          />
        </div>
      )}
    </div>
  );
};

export default ModifyActiveTask;
